import { Controller } from "@hotwired/stimulus";
import axios from "axios";
import * as Sentry from "@sentry/browser";

export default class UserSettingsController extends Controller {
  connect() {
    this.updating = this.data.get("updating");
    this.updated = this.data.get("updated");
    this.error = this.data.get("error");
    this.auth = this.data.get("auth");
  }

  updateUser(event) {
    const { checked, attributeName, url } = this.setCommonData(event);
    const data = {
      user: { [attributeName]: checked },
    };

    this.update(url, data);
  }

  updateProfessional(event) {
    const { checked, attributeName, url } = this.setCommonData(event);
    const data = {
      [attributeName]: checked,
    };

    this.update(url, data);
  }

  setCommonData(event) {
    const checked = event.target.checked;
    const attributeName = event.target.dataset.attrName;
    const url = event.target.dataset.url;

    return { checked, attributeName, url };
  }

  async update(url, data) {
    this.beforeSend(this.updating);

    try {
      await axios({
        method: "patch",
        url: url,
        data: data,
        headers: {
          "X-CSRF-Token": this.auth,
          Accept: "application/json",
        },
      })
        .then(() => {
          this.ajaxSuccess(this.updated);
          this.ajaxComplete();
        })
        .catch((error) => {
          this.handleErrorHelper(error);
        });
    } catch (error) {
      this.handleErrorHelper(error);
    }
  }

  handleErrorHelper(error) {
    Sentry.captureException(error);
    this.ajaxError(this.error);
    this.ajaxComplete();
  }

  beforeSend(updating) {
    $("#loading").html(`
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
      <strong class="mx-3">${updating}</strong>
    `);
    $("#alert").html("");
  }

  ajaxSuccess(updated) {
    $("#alert").html(`
      <div class="alert alert-success custom-alert">${updated}<a href="#" class="btn-close" aria-label="btn-close" data-bs-dismiss="alert"></a></div>
    `);
  }

  ajaxError(error) {
    $("#alert").html(`
      <div class="alert alert-danger custom-alert">${error}<a href="#" class="btn-close" aria-label="btn-close" data-bs-dismiss="alert"></a></div>
    `);
  }

  ajaxComplete() {
    $("#loading").html("");
  }
}
